import React from "react"
import styled from "styled-components"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import BlogCard from "../components/postCard"

const Wrapper = styled.div`
  padding-top: 50px;

  h1 {
    text-align: center;
    color: #fff;
  }

  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 auto;
    padding: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
      max-width: 1024px;
    }
  }
`

const IndexPage = props => {
  const blogs = props.data.blog.edges
  return (
    <Layout>
      <SEO title="Blog" />
      <Wrapper>
        <ul>
          {blogs.map(blog => {
            return (
              <BlogCard
                {...blog.node}
                key={blog.node.id}
                size="small"
                link={blog.node.slug.current}
              />
            )
          })}
        </ul>
      </Wrapper>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query blogPageQuery {
    blog: allSanityPost(sort: { fields: publishedAt, order: DESC }) {
      edges {
        node {
          publishedAt
          featured
          slug {
            current
          }
          title
          summary
          tags {
            id
            name
          }
          id
          body {
            _key
            _type
            style
            list
            children {
              _key
              _type
              marks
              text
            }
          }
          mainImage {
            asset {
              fixed(width: 600, height: 200) {
                ...GatsbySanityImageFixed
              }
              fluid(maxWidth: 400) {
                ...GatsbySanityImageFluid
              }
            }
          }
        }
      }
    }
  }
`
